const PublicLayout = () => import('@/views/auth/SystemUserLayout.vue');
const TenantLayout = () => import('@/views/contactLogin/TenantLayout.vue');
import AuthMiddleware from '@/middleware/auth';

export default [
  {
    path: '/',
    component: PublicLayout,
    children: [
      {
        path: 'signin',
        name: 'SignIn',
        component: () => import('@/views/auth/components/login.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'signin/tenant',
        name: 'TenantSignIn',
        component: () => import('@/views/auth/components/TenantLogin.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'sso-signin',
        name: 'SSOSignIn',
        component: () => import('@/views/auth/SSOSignIn.vue'),
      },
      {
        path: 'signup',
        name: 'SignUp',
        component: () => import('@/views/auth/components/SignUp.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'sso-signup',
        name: 'SSOSignUp',
        component: () => import('@/views/auth/SSOSignUp.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/auth/components/ForgotPassword.vue'),
        beforeEnter: AuthMiddleware.authenticatedRoutes,
      },
      {
        path: 'tenent-forgot-password',
        name: 'TenentForgotPassword',
        component: () => import('@/views/auth/components/TenentForgotPassword.vue'),
        beforeEnter: AuthMiddleware.authenticatedRoutes,
      },
      {
        path: 'forgot-password-verification',
        name: 'ForgotPasswordVerification',
        component: () => import('@/views/auth/components/ForgotPasswordVerification.vue'),
        beforeEnter: AuthMiddleware.authenticatedRoutes,
      },
      {
        path: 'inviteUser',
        name: 'InviteUser',
        component: () => import('@/views/auth/InviteUser.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'verify',
        name: 'UserVerify',
        component: () => import('@/views/auth/UserVerify.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'sso-verify',
        name: 'SSOUserVerify',
        component: () => import('@/views/auth/SSOUserVerify.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
      {
        path: 'send-verification',
        name: 'SendVerification',
        component: () => import('@/views/auth/SendVerification.vue'),
        beforeEnter: AuthMiddleware.guest,
      },
    ],
  },
  {
    path: '/:unique_code',
    component: TenantLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'TenantRegister',
        component: () => import('@/views/contactLogin/register.vue'),
      },
      {
        path: 'otp',
        name: 'TenantOTP',
        component: () => import('@/views/contactLogin/OtpVerification.vue'),
      },
    ],
  },
  {
    path: '/ap/reg',
    component: TenantLayout,
    props: { unique_code: null },
    children: [
      {
        path: '',
        name: 'TenantRegisterPublic',
        component: () => import('@/views/contactLogin/register.vue'),
      },
    ],
  },
  {
    path: '/idp/auth',
    name: 'ExternalSsoAuth',
    component: () => import('@/components/IdpAuthenticationExternal/externalIdpComponent.vue'),
    meta: { title: 'External Sso Auth' },
  },
];
